import { Img } from '@chakra-ui/image'
import { Box, Grid, GridItem, Text } from '@chakra-ui/layout'
import React from 'react'
import HelpNowimages4 from '../../assets/image/HelpNowimages4.webp'
import wizcart from '../../assets/image/wizcart.png'
import reliance from '../../assets/image/reliance.png'
import sony from '../../assets/image/sony.png'
import olay from '../../assets/image/olay.png'
const Ourclients = () => {
    return (
        <Box
            my="5rem"
            maxH={350}
            position="relative"
            height={350}
        >
            <Box
                position="absolute"
                width="100%"
                maxH={350}
                opacity="0.1"
                background="red"
                top={0}
                bottom={0}
            > </Box>
            <Box position="absolute" opacity="0.2">
                <Img
                    objectFit="cover"
                    width="100vw"
                    height={350}
                    maxW="100%"
                    loading='lazy' src={HelpNowimages4} alt="help" />
            </Box>
            <Box
                width={{ base: '85%', sm: '85%', md: '85%', lg: '80%', xl: '80%' }}
                left={{ base: '5%', sm: '5%', md: '5%', lg: '10%', xl: '10%' }}
                position="absolute"
                right="10%"
                top={0}>
                <Box position="relative"
                    mt="4rem"
                    p={{ base: '0', sm: '0', md: '0', lg: '2rem', xl: '2rem' }}>
                    <Text
                        className='main-section'
                        textAlign="center"
                        color="#FB1923"
                        textTransform="uppercase"
                        fontWeight={700}
                        fontSize="3xl"
                        letterSpacing="3px"
                    >OUR CLIENTS</Text>
                    <Grid textAlign="center" mt={16} templateColumns='repeat(4, 1fr)' gap={6}>
                        <GridItem my="auto">
                            <Img mx="auto" loading='lazy' alt='helpnow' src={olay} />
                        </GridItem>
                        <GridItem my="auto">
                            <Img mx="auto" loading='lazy' alt='helpnow' src={reliance} />
                        </GridItem>
                        <GridItem my="auto">
                            <Img mx="auto" loading='lazy' alt='helpnow' src={sony} />
                        </GridItem>
                        <GridItem my="auto">
                            <Img mx="auto" loading='lazy' alt='helpnow' src={wizcart} />
                        </GridItem>
                    </Grid>
                </Box>
            </Box>

        </Box>
    )
}

export default Ourclients